import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export type CustomReimbursementRolloverResolutionAction =
  | 'transfer_to_category'
  | 'return_to_employer_external'
  | 'return_to_employer_internal'
  | 'leave_unrestricted';

export interface CustomReimbursementRolloverResolutionOption {
  id: string;
  name: string;
}

export interface CustomReimbursementRolloverResolutionDialogData {
  sourceCategoryName: string;
  targetCategories: CustomReimbursementRolloverResolutionOption[];
}

export interface CustomReimbursementRolloverResolutionDialogResult {
  action: CustomReimbursementRolloverResolutionAction;
  targetCategoryId?: string;
}

@Component({
    selector: 'app-custom-reimbursement-rollover-resolution-dialog',
    templateUrl: './custom-reimbursement-rollover-resolution-dialog.component.html',
    styleUrls: ['./custom-reimbursement-rollover-resolution-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomReimbursementRolloverResolutionDialogComponent {
  action: CustomReimbursementRolloverResolutionAction = 'leave_unrestricted';
  targetCategoryId = '';
  submitAttempted = false;

  constructor(
    public dialogRef: MatDialogRef<
      CustomReimbursementRolloverResolutionDialogComponent,
      CustomReimbursementRolloverResolutionDialogResult | undefined
    >,
    @Inject(MAT_DIALOG_DATA) public data: CustomReimbursementRolloverResolutionDialogData
  ) {}

  get hasTransferTargets(): boolean {
    return Array.isArray(this.data?.targetCategories) && this.data.targetCategories.length > 0;
  }

  get showTargetCategoryError(): boolean {
    return this.action === 'transfer_to_category' && !this.targetCategoryId;
  }

  onActionChange(action: CustomReimbursementRolloverResolutionAction): void {
    this.action = action;
    this.submitAttempted = false;
    if (action !== 'transfer_to_category') {
      this.targetCategoryId = '';
    }
  }

  onCancel(): void {
    this.dialogRef.close(undefined);
  }

  onConfirm(): void {
    this.submitAttempted = true;
    if (this.showTargetCategoryError) {
      return;
    }

    this.dialogRef.close({
      action: this.action,
      ...(this.action === 'transfer_to_category' ? { targetCategoryId: this.targetCategoryId } : {}),
    });
  }
}
